import { createContext, useContext } from 'react';
import { DashboardContextData } from './dashboardContext.types';

const DashboardContext = createContext<DashboardContextData | null>(null);

export const useDashboardContext = <T = DashboardContextData['dataGetters']>(): DashboardContextData<T> => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboardContext must be used within a DashboardProvider');
  }
  return context as DashboardContextData<T>;
};

export const DashboardContextProvider = DashboardContext.Provider;
